import { ButtonLink, PrimaryButton, SecondaryButton } from '@designsforhealth/dfh-react-components'
import styled, { css } from 'styled-components'

import {
  RequiredSelectField as DfhRequiredSelectField,
  RequiredTextField as DfhRequiredTextField,
} from '../../../../../form/RequiredFields'

export const Form = styled.form`
  width: 100%;
`

export const FormTitle = styled.h5`
  font-family: ${({ theme }) => theme.fontFamilies.roboto};
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.coolGray.cool900};
  letter-spacing: normal;
  margin-bottom: 1rem;
  margin-right: 0.5rem;
`

export const FirstRow = styled.div`
  width: 100%;
  max-width: 505px;
`

export const SecondRow = styled.div`
  width: 100%;
  max-width: 312px;
`

const commonFieldStyles = css`
  label {
    color: ${({ theme }) => theme.colors.coolGray.cool600};
  }
  input {
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  }
  .MuiInputLabel-asterisk {
    color: ${({ theme }) => theme.colors.poppyRed.shade500};
  }
`

export const RequiredTextField = styled(DfhRequiredTextField)`
  ${commonFieldStyles};
  margin-bottom: 1rem;
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const RequiredSelectField = styled(DfhRequiredSelectField)`
  ${commonFieldStyles};
`

export const SaveButton = styled(PrimaryButton)`
  width: 100%;
  max-width: 236px;
  border-radius: 8px;
`

export const CancelButton = styled(SecondaryButton)`
  width: 100%;
  max-width: 236px;
  border-radius: 8px;
`

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 50px;
  margin-top: 2rem;
  gap: 10px;
  @media (min-width: 576px) {
    gap: 32px;
  }
`

export const DeleteAccountDetails = styled(ButtonLink)`
  color: ${({ theme }) => theme.colors.semantic.error};
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.06em;
  text-decoration: underline;
`

export const AccountInformationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
`

export const CheckmarkCircleIcon = styled.img`
  display: block;
  width: 16px;
  height: 16px;
`
